<template>
  <div class="file-size">
    <label>{{ $t('root.filters.size') }}</label>

    <input v-model="min" placeholder='min bytes' class="form-control" v-on:keydown.enter.prevent="filter"/>
    <input v-model="max" placeholder='max bytes' class="form-control" v-on:keydown.enter.prevent="filter"/>

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')" >{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        min: null,
        max: null,
      }
    },
    computed: {
      parsedMin() {
        return parseInt(this.min)
      },
      parsedMax() {
        return parseInt(this.max)
      },
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[size_gteq]']
        delete newQuery['filters[size_lteq]']

        if (this.parsedMin)
          newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, 'filters[size_gteq]': this.parsedMin })

        if (this.parsedMax)
          newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, 'filters[size_lteq]': this.parsedMax})

        this.$router.push({ query: newQuery })
      },
    }
  }
</script>
<style lang="sass" scoped>
  .file-size
    width: 200px
    padding: 10px
  .float-right
    margin-top: 15px
  .form-control
    margin-bottom: 10px
</style>
